import { api } from '../config/api'
import { teamListDefaultPageSize } from '../utils/constants'

const schoolBaseEndpoint = '/SchoolApi'

export const getSchoolInfo = schoolId => api.get(`${schoolBaseEndpoint}/${schoolId}`)

export const saveSchoolInfo = schoolInfo => api.put(`${schoolBaseEndpoint}/${schoolInfo.id}`, schoolInfo)

export const getUsersBySchool = ({ id, filters: { pageNumber = 0, pageSize = teamListDefaultPageSize, ...filters } }) =>
  api.get(`${schoolBaseEndpoint}/GetUsersStatusBySchool/${id}`, { params: { pageNumber, pageSize, ...filters } })

export const usedAddress = params => api.get(`${schoolBaseEndpoint}/SchoolExists`, { params })

export const removeTeamMembers = (schoolId, ids) => api.put(`${schoolBaseEndpoint}/${schoolId}/RemoveMembers`, ids)

export const cancelInvitation = (user) => api.post('/AccountApi/CancelInvitation', user)

export const editSchoolUser = (schoolId, userData) => api.post(`${schoolBaseEndpoint}/${schoolId}/EditUser`, userData)
